import React from 'react'
import { Col, Row } from 'react-bootstrap'
import './helpyou.scss'
import { Link } from 'react-router-dom'
import { ContactIcon } from '../../../icon/icons'
const Helpyou = () => {
    return (
        <div className='help_you'>
                <Row>
                    <Col sm={12} md={7}>
                        <div className='first_section'>
                            <div className='common_heading'>
                                <h2>Have a question? Let’s talk—we’re happy to help you.</h2>
                                <p>We know the business insurance world can be complex.
                                    That’s why we’ve put together a list of <Link to=""> frequently asked questions </Link>
                                    to help you find the answers you need.
                                </p>
                            </div>
                            <div className='action_btns'>
                                <Link to="" className='blue_btn'>Claims</Link>
                                <Link to="" className='blue_btn'>Find an agent</Link>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} md={5}>
                        <div className='news-common-card'>
                            {/* Content Section */}
                            <div className='Content'>
                                <div className='Heading'>
                                    <h3>Need to get a hold of us?</h3>
                                    <div className='contact_number'>
                                        <ContactIcon /><h3>800-473-6879</h3>
                                    </div>
                                </div>
                                <a className='link' href="">
                                    <span>Send us a fax {">"}</span>
                                </a>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12}>
                        <div className='second_section'>
                            <div className='blue_card'>
                                {/* Content Section */}
                                <div className='Content'>
                                    <div className='Heading'>
                                        <h3>As a Sentry customer, you can perform a range of tasks without logging in to your online account. Find the tools and resources you need.
                                        </h3>
                                    </div>
                                    <a className='link' href="">
                                        <span>For customers</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
        </div>
    )
}

export default Helpyou
